import React from 'react';
import styles from './ProductsError.module.scss';

const ProductsError = () => (
  <p className={styles.errorText}>
    Something went wrong displaying products, we&apos;re working on it…
  </p>
);

export default ProductsError;
